export default __webpack_public_path__ + "2b139bb7b5c300e1a4e1a74b3929c8bf.svg";